// this is a wrapper for window.location methods and properties that allows stubbing them in tests
export const Location = {
  change: (href: string) => {
    window.location.href = href;
  },
};
